module.exports = "../dist/frontend/icons/letters/a-blue.svg?437bb3d2a1d2fa23d03dcf7aefceefd2";